/* Custom cart drawer: shipping protection toggle, discount codes, auto-add SP */
(function () {
  const cfg = window.CC_CONFIG || {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const OPT_OUT_KEY = 'cc_sp_optout';
  let busy = false;

  const jsonPost = (url, body) =>
    fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());

  const getCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

  function setLoading(on) {
    const inner = document.querySelector('#CartDrawer .drawer__inner');
    if (inner) inner.classList.toggle('cc-loading', on);
  }

  async function refreshDrawer() {
    const res = await fetch(`${root}?sections=cart-drawer,cart-icon-bubble`);
    const data = await res.json();
    const parser = new DOMParser();

    if (data['cart-drawer']) {
      const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('.drawer__inner');
      const current = document.querySelector('#CartDrawer .drawer__inner');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const drawer = document.querySelector('cart-drawer');
      const freshDrawer = doc.querySelector('cart-drawer');
      if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    }
    if (data['cart-icon-bubble']) {
      const doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
      const fresh = doc.querySelector('.shopify-section');
      const current = document.getElementById('cart-icon-bubble');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
  }

  async function run(task) {
    if (busy) return;
    busy = true;
    setLoading(true);
    try {
      await task();
      await refreshDrawer();
    } catch (e) {
      console.error('[custom-cart]', e);
    } finally {
      setLoading(false);
      busy = false;
    }
  }

  /* ---------- Shipping protection ---------- */
  const spId = Number(cfg.spVariantId || 0);

  async function syncShippingProtection() {
    if (!spId || busy) return;
    const cart = await getCart();
    const hasSP = cart.items.some((i) => i.variant_id === spId);
    const otherCount = cart.items.filter((i) => i.variant_id !== spId).reduce((n, i) => n + i.quantity, 0);

    if (otherCount === 0 && hasSP) {
      return run(() => jsonPost('cart/change.js', { id: String(spId), quantity: 0 }));
    }
    if (cfg.spDefaultOn && otherCount > 0 && !hasSP && !sessionStorage.getItem(OPT_OUT_KEY)) {
      return run(() => jsonPost('cart/add.js', { items: [{ id: spId, quantity: 1 }] }));
    }
  }

  document.addEventListener('change', (e) => {
    const toggle = e.target.closest('[data-cc-sp-toggle]');
    if (!toggle) return;
    const id = Number(toggle.dataset.variantId);
    if (toggle.checked) {
      sessionStorage.removeItem(OPT_OUT_KEY);
      run(() => jsonPost('cart/add.js', { items: [{ id, quantity: 1 }] }));
    } else {
      sessionStorage.setItem(OPT_OUT_KEY, '1');
      run(() => jsonPost('cart/change.js', { id: String(id), quantity: 0 }));
    }
  });

  /* ---------- Discount codes ---------- */
  function currentCodes() {
    const wrap = document.querySelector('.cc-discount');
    return ((wrap && wrap.dataset.ccCodes) || '').split(',').map((c) => c.trim()).filter(Boolean);
  }

  function applyCode() {
    const input = document.querySelector('[data-cc-discount-input]');
    const code = input && input.value.trim();
    if (!code) return;
    const codes = currentCodes().filter((c) => c.toLowerCase() !== code.toLowerCase());
    codes.push(code);
    run(() => jsonPost('cart/update.js', { discount: codes.join(',') }));
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cc-discount-apply]')) {
      e.preventDefault();
      applyCode();
      return;
    }
    const remove = e.target.closest('[data-cc-discount-remove]');
    if (remove) {
      e.preventDefault();
      const code = remove.dataset.ccDiscountRemove.toLowerCase();
      const codes = currentCodes().filter((c) => c.toLowerCase() !== code);
      run(() => jsonPost('cart/update.js', { discount: codes.join(',') }));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches('[data-cc-discount-input]')) {
      e.preventDefault();
      applyCode();
    }
  });

  /* ---------- Hooks ---------- */
  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // let Dawn finish rendering first
        setTimeout(syncShippingProtection, 150);
      });
    }
    syncShippingProtection();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
